import { ExternalLink } from '@atlassian/mpac-primitives';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const SlaHelper = /*#__PURE__*/_jsxs(_Fragment, {
  children: ["Provide a URL for your Service Level Agreement (SLA). This is required for the", ' ', /*#__PURE__*/_jsx(ExternalLink, {
    size: "small",
    href: "https://go.atlassian.com/atlassian-verified",
    children: "Top Vendor"
  }), ' ', "program."]
});
export const SupportHoursHelper = /*#__PURE__*/_jsxs(_Fragment, {
  children: ["Detail your support offerings here. The", ' ', /*#__PURE__*/_jsx(ExternalLink, {
    size: "small",
    href: "https://go.atlassian.com/atlassian-verified",
    children: "Top Vendor"
  }), ' ', "program requires 8 hours of support per day, 5 days a week."]
});
export const TopVendorProgramHelper = /*#__PURE__*/_jsxs(_Fragment, {
  children: ["This is required for the", ' ', /*#__PURE__*/_jsx(ExternalLink, {
    size: "small",
    href: "https://go.atlassian.com/atlassian-verified",
    children: "Top Vendor"
  }), ' ', "program."]
});